import { render, staticRenderFns } from "./UploadSocialId.vue?vue&type=template&id=a48bbed8&scoped=true&"
import script from "./UploadSocialId.vue?vue&type=script&lang=js&"
export * from "./UploadSocialId.vue?vue&type=script&lang=js&"
import style0 from "./UploadSocialId.vue?vue&type=style&index=0&id=a48bbed8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48bbed8",
  null
  
)

export default component.exports